import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { StatusSelect, StatusOption } from './styles';
import useServiceStatus from '../../hooks/useServiceStatus';
import { incidentsStatus } from '../../../../config/constants/incidentsStatus';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';

const SelectStatus = ({ value, onChange, allowedStatus, multiple }) => {
  const { translate: t } = useDictionaryTranslation();
  const { serviceStatus } = useServiceStatus();
  const mode = multiple ? 'multiple' : null;
  const statusList = useMemo(() => {
    if (!serviceStatus?.length) return serviceStatus;
    return serviceStatus.filter((status) => allowedStatus?.includes(status.status));
  }, [serviceStatus, allowedStatus]);

  return (
    <StatusSelect
      mode={mode}
      allowClear
      value={value}
      onChange={onChange}
      placeholder={t('selectStatus')}
      showSearch={false}
    >
      {statusList.map((status) => (
        <StatusOption key={status._id} value={status.status}>
          <span>{status.name}</span>
        </StatusOption>
      ))}
    </StatusSelect>
  );
};

SelectStatus.defaultProps = {
  allowedStatus: Object.values(incidentsStatus),
};

SelectStatus.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  allowedStatus: PropTypes.arrayOf(PropTypes.oneOf(Object.values(incidentsStatus).map(({ status }) => status))),
};
export default SelectStatus;
